import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";
import * as pActs from "../actions/profiles-actions";
import * as wConsts from "../consts/website-consts";

const TitleStyle = {
  fontSize: "1.4rem", color: "#1ba022",
  display: "block", margin: "4px auto", clear: "both"
}
const DescStyle = {
  fontSize: "1.2rem", color: "#454545",
  display: "block", margin: "4px auto"
}

class SearchItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Index: props.Item.Index,
      Title: props.Item.Title,
      Description: props.Item.Description,
      Url: props.Item.Url,
      ImageUrl: props.Item.ImageUrl,
      Referer: props.Referer
    }
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  isLocal(url) {
    let ref = this.state.Referer;
    let loc = this.getLocation(ref).host;
    url = this.getLocation(url).host;
    if(loc === url) {
      return true;
    } else {
      //console.log(`${loc}!=${url}`);
    }
    return false;
  }

  getLocation(href) {
    try {
      let match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
      const resp = match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
      }
      return resp;
    } catch(ex) {}
    return {}
  }

  render() {
    const itm = this.state;
    return (
      <React.Fragment>
        <div className="col_100 search-item">
          <table style={{border: "none"}}>
            <tbody>
            <tr style={{border: "none"}}>
              <td style={{width: "100px", border: "none", padding: "5px"}}>
                {this.isLocal(itm.Url) ?
                  <Link style={TitleStyle} to={this.getLocation(itm.Url).pathname + this.getLocation(itm.Url).search}><img src={itm.ImageUrl} alt={itm.Title}/></Link> : <a href={itm.Url} style={TitleStyle} target={"_blank"}><img src={itm.ImageUrl} alt={itm.Title}/></a>
                }
              </td>
              <td style={{border: "none", padding: "5px"}}>
                {this.isLocal(itm.Url) ?
                  <Link style={TitleStyle} to={this.getLocation(itm.Url).pathname+this.getLocation(itm.Url).search}>{itm.Title}</Link> : <a style={TitleStyle} href={itm.Url} target={"_blank"}>{itm.Title}</a>
                }
                <div style={DescStyle} dangerouslySetInnerHTML={{__html: itm.Description}}></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}


export default SearchItem;
